import { Injectable } from "@angular/core";
import { DataConverterHelperService } from "@app/shared/services/converter/data-converter-helper.service";
import { LocalizerService } from "../localization/localizer.service";

@Injectable({
    providedIn: "root",
})
export class TemperatureConverterService {
    constructor() {
        if (LocalizerService.supportedLanguage !== "en") {
            this.defaultUnits.output = "°C";
        }
    }

    public defaultUnits = { input: "°C", output: "°F" };

    /**
     * Convert a temp from Celsius to Fahrenheit
     *
     * @param this
     * @param temp The temperature to convert
     */
    public celsiusToFahrenheit(this: void, temp: string): string {
        const tmpTemp: number = parseFloat(temp) * (9 / 5) + 32;
        return DataConverterHelperService.mathRound(tmpTemp) + "";
    }

    /**
     * Convert a temp from Fahrenheit to Celsius
     *
     * @param this
     * @param temp The temperature to convert
     */
    public fahrenheitToCelsius(this: void, temp) {
        const tmpTemp = (parseFloat(temp) - 32) * (5 / 9);
        return tmpTemp.toFixed(2);
    }

    /**
     * Converts an output value to an input value if the units are different
     *
     * @param value The value to convert
     * @param units The input and output units to work with
     * @param checkAgainstDefaultInput Whether to check units.input against the default input unit
     */
    public getInputValue(value, units = this.defaultUnits, checkAgainstDefaultInput?): number {
        let convertedValue = value;
        let converter = this.fahrenheitToCelsius;
        const _units = units || this.defaultUnits;
        // If units is true AND (the input and output units supplied are inequal) OR (the default input is not equal to the unit input)
        // This means we want to perform some kind of conversion
        if (
            _units &&
            ((!checkAgainstDefaultInput && _units.input !== _units.output) ||
                (checkAgainstDefaultInput && this.defaultUnits.input !== _units.input))
        ) {
            if (_units.input === "°F") {
                converter = this.celsiusToFahrenheit;
            }

            convertedValue = converter(value);
        }

        // Since toFixed() returns a string, need to convert it back to a float, hence - 0
        return parseFloat(parseFloat(convertedValue).toFixed(2));
    }

    /**
     * Converts an input value to an output value if the units are different
     *
     * @param value The value to convert
     * @param units The input and output units to work with
     * @param checkAgainstDefaultInput
     */
    public getOutputValue(value, units = this.defaultUnits, checkAgainstDefaultInput?): number {
        let convertedValue = value;
        let converter = this.celsiusToFahrenheit;
        const _units = units || this.defaultUnits;

        if (
            _units &&
            ((!checkAgainstDefaultInput && _units.input !== _units.output) ||
                (checkAgainstDefaultInput && this.defaultUnits.input !== _units.output))
        ) {
            if (_units.output === "°C") {
                converter = this.fahrenheitToCelsius;
            }

            convertedValue = converter(value);
        }

        return parseInt(convertedValue, 10);
    }
}
